export const airplayIcon = [
  "24 24",
  `     
       <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5,17H4
	c-1.104,0-2-0.896-2-2V5c0-1.104,0.896-2,2-2h16c1.104,0,2,0.896,2,2v10c0,1.104-0.896,2-2,2h-1 M12,15l5,6H7L12,15z"/>
        
          `,
];
